import {
  BASE_PLAN_SUB_TYPES,
  planTypes,
  autoAddTypes,
  AUTO_ADD_BASE_PLAN_CODES,
  AUDIO_SUB_TYPES,
  unlockBizAndBizPlusCountByRetention,
} from '@/common/constants';
import { flowTypes, pageConfig } from '@/common/service/page-config';
import { getPlanTypeByCategory } from '@/common/service/parse';
import { $query, $config, $context } from '@/global-install';
import store from '@/store';
import { plansof } from '@/utils/chain';
import cookie from 'js-cookie';
import _, { get } from 'lodash';
import { computedPbxCallingPlans } from '@/common/service/computers/plans/pbx';
import { isEmptyVal } from '@/utils';
import { isFromCampaignLink } from '@/views/config/coupon/helper/utils';
import { reactivatePlan } from '@/common/service/checkout-utils';
import { ONLINE_NOT_SUPPORT_BILLING_CYCLE } from '@/common/service/non-standard-billing-cycle-utils';
import { AccountType } from '@/common/constants';
import { isFromShoppingCart } from '@/views/config/shopping-cart/persist/plan-remove';

export const ZOOM_MEETING_SUB_TYPES = {
  PRO: 'pro',
  PRO25: 'pro25',
  PRO50: 'pro50',
  PRO_FREE_TRIAL: 'pro_freetrial',
  BIZ: 'biz',
  PRO_PLUS: 'zoneproplus',
  BIZ_PLUS: 'bizplus',
  BIZ_INR: 'biz_inr',
  EDUCATION: 'education',
  ENTERPRISE: 'bundle',
  EDU_SITE: 'edu_site',
  ZOOM_ONE_PRO_PLUS: 'zone_proplus',
  ZOOM_ONE_BIZ_PLUS: 'zone_bizplus',
  ZOOM_ONE_ENTERPRISE: 'zone_enterprise',
  ZOOM_ONE_ENTERPRISE_PLUS: 'zone_enterprise_plus',
  ZONE_EDU_SCH_CMP: 'zoneduschcmp', // from backend category
  ZONE_EDU_PLUS: 'zopschcmp', // customized plancode, identify that it's plus
  SINGLE_USE_PRO: 'single_use_pro',
};

export const ZOOM_METTING_EDU_I18N_TITLE_KEY = 'billing.planform.title.zoom_one_education';

export const getCategoryNameI18nKey = (category) => {
  switch (category) {
    case ZOOM_MEETING_SUB_TYPES.BIZ:
      return 'billing.business';
    case ZOOM_MEETING_SUB_TYPES.PRO:
      return 'billing.pro';
    case ZOOM_MEETING_SUB_TYPES.BIZ_PLUS:
      return 'billing.planform.title.biz_plus';
    case ZOOM_MEETING_SUB_TYPES.PRO_PLUS:
      return 'billing.zone_pro_plus.brief_title';
    case ZOOM_MEETING_SUB_TYPES.EDUCATION:
      return ZOOM_METTING_EDU_I18N_TITLE_KEY;
  }
};

export const getTitleNameI18nKey = (category) => {
  switch (category) {
    case ZOOM_MEETING_SUB_TYPES.BIZ:
      return 'billing.planform.title.zoom_one_biz';
    case ZOOM_MEETING_SUB_TYPES.PRO:
      return 'billing.planform.title.zoom_one_pro';
    case ZOOM_MEETING_SUB_TYPES.BIZ_PLUS:
      return 'billing.planform.title.zoom_one_biz_plus';
    case ZOOM_MEETING_SUB_TYPES.PRO_PLUS:
      return 'billing.zone_pro_plus.title';
    case ZOOM_MEETING_SUB_TYPES.EDUCATION:
      return ZOOM_METTING_EDU_I18N_TITLE_KEY;
    case ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP:
      return 'billing.planform.title.zo_edu_sch_cmp';
  }
};

export const DEFAULT_MEETING_PLAN_CAPACITY = {
  category: 'pro',
  billingCycle: 'annual',
  selectedNumber: 1,
};

export const DEFAULT_MEETING_BIZ_PLAN_CAPACITY = {
  category: 'biz',
  billingCycle: 'annual',
  selectedNumber: 1,
};

export const DEFAULT_SCHEDULER_PLAN_CAPACITY = {
  category: 'zsched',
  billingCycle: 'annual',
  selectedNumber: 1,
};

export const PARENT_TYPES_ZOOM_MEETING_ADDON_FOR = [
  planTypes.ZOOM_SCHEDULER,
  planTypes.ZOOM_WHITEBOARD,
  planTypes.ZOOM_WHITEBOARD_PLUS,
  planTypes.ZOOM_ROOMS,
  planTypes.ZOOM_DOCS,
];
export const PARENT_TYPES_ZOOM_MEETING_ADDON_FOR_STANDALONE = [
  planTypes.ZOOM_WHITEBOARD,
  planTypes.ZOOM_WHITEBOARD_PLUS,
  planTypes.ZOOM_DOCS,
];
export const isZoomMeetingAsAddonCard = () => {
  const { plan = 'pro', from } = pageConfig;
  if (
    pageConfig.type ===
    flowTypes.add2cart /* // FREE TRIAL - addon is already hidden in CONFIG view file || pageConfig.type === flowTypes.buyTrial || pageConfig.type === flowTypes.add2trial */
  )
    return false;
  const fromStandAlone = PARENT_TYPES_ZOOM_MEETING_ADDON_FOR_STANDALONE.includes(getPlanTypeByCategory(from));
  return PARENT_TYPES_ZOOM_MEETING_ADDON_FOR.includes(getPlanTypeByCategory(plan)) || fromStandAlone;
};
export const isZoomSchedulerAsAddonCard = () => {
  const { plan = 'pro', from } = pageConfig;
  const fromStandAlone = PARENT_TYPES_ZOOM_MEETING_ADDON_FOR_STANDALONE.includes(getPlanTypeByCategory(from));
  const planType = $config('isNewSuccessPage') && plan === 'z1s' ? planTypes.ZOOM_MEETING : getPlanTypeByCategory(plan);
  const flowTypesSupported = $config('isNewSuccessPage')
    ? true
    : [flowTypes.basic2pro, flowTypes.buyNow].includes(pageConfig.type);
  return flowTypesSupported && [planTypes.ZOOM_MEETING, planTypes.ZONE_PRO_PLUS].includes(planType) && !fromStandAlone;
};

// TODO: would be removed after webinar and english region features done.
export const additionalZoomSchedulerAsAddonCardCheck = (getSelectedPlans = []) => {
  const cookieLang = cookie.get('_zm_lang');
  const { from = 'pro', enableSchedulerOnlineBuy = false } = pageConfig;
  const isBizOrBizPlus = plansof(getSelectedPlans)
    .category(BASE_PLAN_SUB_TYPES.BIZ, BASE_PLAN_SUB_TYPES.ZOOM_ONE_BIZ_PLUS)
    .has();
  // German, Japanese, French, Spanish, Chinese Traditional and Simplified, Portuguese, Italian, Dutch, and Korean
  const schedulerEnabledLanguages = [
    'en-US',
    'de-DE',
    'jp-JP',
    'fr-FR',
    'es-ES',
    'zh-CN',
    'zh-TW',
    'pt-PT',
    'it-IT',
    'nl-NL',
    'ko-KO',
  ];

  return (
    isZoomSchedulerAsAddonCard() &&
    !isBizOrBizPlus &&
    ![planTypes.WEBINAR, planTypes.ZOOM_EVENTS].includes(
      getPlanTypeByCategory(from),
    ) /* Don't touch webinar & events */ &&
    schedulerEnabledLanguages.includes(cookieLang) &&
    enableSchedulerOnlineBuy /* Currency check */
  );
};

export const isBizPlusContext =
  pageConfig?.editConfig?.planType === planTypes.ZOOM_ONE_BUNDLE ||
  getPlanTypeByCategory?.($query?.plan) === planTypes.ZOOM_ONE_BUNDLE;
export const isBizPlusEditContext = (plans) => isBizPlusContext && plansof(plans).type(planTypes.ZOOM_ONE_BUNDLE).has();
export const isBizEditContext =
  pageConfig.type === flowTypes.edit && pageConfig?.editConfig?.category === BASE_PLAN_SUB_TYPES.BIZ;

export const isProPlusContext =
  pageConfig?.editConfig?.planType === planTypes.ZONE_PRO_PLUS ||
  getPlanTypeByCategory?.($query?.plan) === planTypes.ZONE_PRO_PLUS;
export const isProPlusEditContext = (plans) => isProPlusContext && plansof(plans).type(planTypes.ZONE_PRO_PLUS).has();

export const isProContext =
  pageConfig?.editConfig?.planType === planTypes.ZOOM_MEETING &&
  pageConfig?.editConfig?.category === BASE_PLAN_SUB_TYPES.PRO;
export const isBizContext = pageConfig?.editConfig?.planType === planTypes.ZOOM_MEETING && pageConfig?.editConfig?.category === BASE_PLAN_SUB_TYPES.BIZ

export const isEduSchCmpPlusContext =
  pageConfig?.editConfig?.planType === planTypes.ZONE_EDU_PLUS ||
  getPlanTypeByCategory?.($query?.plan) === planTypes.ZONE_EDU_PLUS;
export const isEduSchCmpPlusEditContext = (plans) =>
  isEduSchCmpPlusContext && plansof(plans).type(planTypes.ZONE_EDU_PLUS).has();

export const isZoneBundleContext = isBizPlusContext || isProPlusContext || isEduSchCmpPlusContext;

// promotion not include pbx plan, just for zoom one bundle plan
export const onlyPromotionZoneBundleForCampaign = (getSelectedPlans = []) => {
  const fromCampaign = isEmptyVal(pageConfig.marketingCoupon) === false;
  const fromCardId = isEmptyVal(pageConfig.preloadCartInfo) === false;
  const fromInitLink = !isEmptyVal(pageConfig.init_categories);

  // from campaign link or generate cart id
  if (fromCampaign || fromCardId || fromInitLink) {
    const hasZonePlan = _.some(getSelectedPlans, (plan) =>
      [planTypes.ZOOM_ONE_BUNDLE, planTypes.ZONE_PRO_PLUS].includes(plan.type),
    );
    // exist zoom one bundle plan for promotion
    if (!hasZonePlan) return false;

    const includePbxCallingPlan = computedPbxCallingPlans(getSelectedPlans).length;
    // not include pbx plan promotion
    return !includePbxCallingPlan;
  }

  return false;
};

export const isShowRemoveBtn = (planType) => {
  if (isFromShoppingCart()) {
    return true;
  }
  const isMajorPlan = pageConfig?.editConfig?.planType === planType;
  if (isMajorPlan) return false;
  return pageConfig.type === flowTypes.basic2pro || pageConfig.type === flowTypes.buyNow;
};

export const isShowBizCard = () => {
  const { hasHealthcareBiz, fromCampaignLink, plansofBizBundle, hasDowngradeRequest, migratePlanState } = store.getters;
  const { boughtBizPlan, boughtBizPlusPlan } = plansofBizBundle;
  // check if has_downgrade_request is true, if it is true, that means there has biz plus downgrade to biz job
  const hasDowngradeRequestForBizPlus = boughtBizPlusPlan.find((p) => hasDowngradeRequest[p.plan_code]);
  // check if has pending activation/downgrade biz plan
  let hasPendingBizPlan = checkBizPlanIsPending();
  // if is pro plus to biz plus
  const isUpgrade = migratePlanState.is.upgrade;
  // if has biz plan, hide biz card
  return (
    !isUpgrade &&
    !hasPendingBizPlan &&
    !hasDowngradeRequestForBizPlus &&
    !boughtBizPlan.length &&
    !hasHealthcareBiz &&
    !fromCampaignLink
  );
};

export const getMeetingPlanByCategory = (plans, category = BASE_PLAN_SUB_TYPES.BIZ) => {
  return plansof(plans).type(planTypes.ZOOM_MEETING).category(category).get(0) || {};
};

export const checkBizPlanIsPending = () => {
  // check if has pending activation/downgrade biz plan
  const { basicConfig, planMapFlat } = store.getters;
  const { pendingPlanCodes = [] } = basicConfig;
  const bizPlans = plansof(planMapFlat).type(planTypes.ZOOM_MEETING).category(BASE_PLAN_SUB_TYPES.BIZ).get();
  return !!bizPlans.find((p) => pendingPlanCodes.includes(p.plan_code));
};

export const isTypeInAutoAddTypes = (selectedPlans = []) => {
  return selectedPlans.some((plan) => autoAddTypes.includes(plan.type));
};

/**
 * is support auto add
 * @returns allow auto add
 */
export const isAutoAddable = () => {
  if (![flowTypes.basic2pro, flowTypes.buyNow, flowTypes.add2cart].includes(pageConfig.type)) {
    return false;
  }
  if (pageConfig.type === flowTypes.add2cart && !$config('enableAddonsAutoAddForAdd2Cart')) {
    return false;
  }
  if ([flowTypes.basic2pro, flowTypes.buyNow].includes(pageConfig.type) && !$config('enableAddonsAutoAdd')) {
    return false;
  }
  if (pageConfig.accountType === AccountType.ACCOUNT_ACTIVE_HOST) {
    return false;
  }
  const {
    isOnlineFreeTrailAccount,
    boughtPlans,
    fromCampaignLink,
    getCurrentMeetingPlans,
    basicConfig,
    plancodeMapSubscriptionDisabled,
    useSpecialSupportCoupon,
  } = store.getters;
  // if the customer exist special support coupon, then auto applied, will block auto add function
  if (useSpecialSupportCoupon) {
    return false;
  }
  if (isOnlineFreeTrailAccount) {
    return false;
  }
  if (fromCampaignLink || isFromCampaignLink()) {
    return false;
  }
  // Audio Unlimited
  if (boughtPlans.some((plan) => plan.type === planTypes.TOLLFREE && plan.category === AUDIO_SUB_TYPES.UNLIMITED)) {
    return false;
  }
  // only allow account with one base meeting plan
  if (getCurrentMeetingPlans.length !== 1) {
    return false;
  }
  const autoAddBasePlans = getCurrentMeetingPlans.filter((plan) => AUTO_ADD_BASE_PLAN_CODES.includes(plan.plan_code));
  if (autoAddBasePlans.length !== 1) {
    return false;
  }
  // special billing cycle
  if (ONLINE_NOT_SUPPORT_BILLING_CYCLE.includes(autoAddBasePlans[0]?.billing_cycle)) {
    return false;
  }
  // multiple rate plan
  if (basicConfig?.isCustomPricing4MajorPlan || autoAddBasePlans.some((plan) => plan?.ratePlans?.length > 1)) {
    return false;
  }
  // disable status
  if (autoAddBasePlans.some((plan) => plancodeMapSubscriptionDisabled[plan.plan_code])) {
    return false;
  }
  // pro free trial
  if (boughtPlans.some((p) => p.isSingleUseProFreeTrial)) {
    return false;
  }
  return true;
};

/**
 * is support auto add and a plan that supports auto add is currently selected
 * @returns boolean
 */
export const isAutoAddableAndAutoAddPlanSelected = () => {
  return isAutoAddable() && isTypeInAutoAddTypes(store.getters.getSelectedPlans);
};

export const isBulkLicenseAccountBase = () => {
  const { getBoughtBasePlanInfo, basicConfig } = store.getters;
  return basicConfig?.isBulkLicenseAccount && getBoughtBasePlanInfo?.planType === planTypes.ZOOM_MEETING;
};

export const bizCanDowngrade = () => {
  const { getBoughtBasePlanInfo, boughtPlansGroupByCategoryCode, boughtPlans, freeTrialPlans, basicConfig } =
    store.getters;

  const boughtBaseCategory = get(getBoughtBasePlanInfo.plans || [], '0.zoomMeetingCategory', '');

  // edit flow and current edit business plan
  if (
    $context.flow === flowTypes.biz2pro &&
    [ZOOM_MEETING_SUB_TYPES.BIZ, ZOOM_MEETING_SUB_TYPES.BIZ_INR].includes(boughtBaseCategory)
  ) {
    // bought unlimited audio plan
    const isBoughtUnlimitedAudio = Object.keys(boughtPlansGroupByCategoryCode).some((category) => {
      return [AUDIO_SUB_TYPES.UNLIMITED].includes(category);
    });
    // have bought zoom one biz plus plan
    const boughtZoneBundlePlans = boughtPlans?.filter((plan) => plan?.type === planTypes.ZOOM_ONE_BUNDLE);
    // have bought zoom one biz plus free trial plan
    const boughtZoneBundleFtPlans = freeTrialPlans?.filter((plan) => plan?.type === planTypes.ZOOM_ONE_BUNDLE);
    // is allow downSell
    const disableDownSell = basicConfig?.downSellData?.disableDownSell;
    return (
      !boughtZoneBundlePlans?.length &&
      !boughtZoneBundleFtPlans?.length &&
      !isBoughtUnlimitedAudio &&
      !disableDownSell &&
      !isBulkLicenseAccountBase()
    );
  }
  return false;
};

export const isInUnlockBizCountRetentionFlow = () => {
  return (
    $context.flow === flowTypes.edit &&
    unlockBizAndBizPlusCountByRetention &&
    !plansof(store.getters.getSelectedPlans).type(planTypes.ZOOM_ONE_BUNDLE).has() &&
    plansof(store.getters.getSelectedPlans).category(BASE_PLAN_SUB_TYPES.BIZ).has()
  );
};

export const reactiveBizPlanIfCancelled = async () => {
  const { boughtPlans } = store.getters;
  const bizPlan = plansof(boughtPlans).type(planTypes.ZOOM_MEETING).category(BASE_PLAN_SUB_TYPES.BIZ).get(0);
  if (bizPlan && bizPlan.cancelled === 1) {
    await reactivatePlan(bizPlan);
  }
};

